import { Box } from '@mui/material'

import { SlideType } from '../../../../../_types'

export interface CarouselSlideProps {
  slide: SlideType
  isActiveSlide: boolean
  onSlideSelect: any
}
export const CarouselSlide: React.FC<CarouselSlideProps> = ({
  slide,
  isActiveSlide,
  onSlideSelect,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        cursor: !isActiveSlide ? 'pointer' : 'default',
        opacity: !isActiveSlide ? 1 : 0.4,
      }}
      onClick={() => onSlideSelect(slide?.index)}
    >
      <Box
        sx={{
          position: 'fixed',
          bottom: '2px',
          backgroundColor: 'black',
          opacity: 0.6,
          color: 'white',
          borderRadius: '6px',
          paddingX: '6px',
          fontSize: '12px',
        }}
      >
        {slide?.index + 1}
      </Box>
      <img width="100%" alt="" src={slide?.imgSrc} />
    </Box>
  )
}

export default CarouselSlide
